// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';

// ==============================|| LOADER ||============================== //
// Global loading indicator (template style): a progress bar pinned to the top of the
// app. `position: fixed` paints it above any element without affecting the layout.

export default function Loader() {
	return (
		<Box sx={{ position: 'fixed', top: 0, left: 0, zIndex: 2001, width: 1 }}>
			<LinearProgress color="primary" sx={{ height: 8, borderRadius: 0 }} />
		</Box>
	);
}
